import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  menuTop: {
    marginLeft: theme.spacing(2),
  },
}));
